module.exports = __webpack_public_path__ + "static/golden-spikes-83f3d1d5a16c360ede867c3e8503f85a.svg";